import { getController, postController } from '@/controllers/request';
import router from '@/router/index';
import { callNotifications, errorMsg } from '@/utils/mixins';
export default {
  namespaced: true,
  state: {
    auth: true,
    loading: false,
    offerStatus: {},
    isSessionExists: false,
    isSessionLost: false,
    showRestorePasswordButton: false,
    user: {},
    sso: {}
  },
  mixins: [errorMsg, callNotifications],
  mutations: {
    removeAuth(state) {
      state.auth = false;
      state.offerStatus = {};
      state.isSessionExists = false;
      state.isSessionLost = false;
      state.user = {};
      localStorage.setItem('auth', false);
      if (localStorage.getItem('sessionId')) {
        localStorage.removeItem('sessionId');
      }
    },
    setOfferStatus(state, status) {
      state.offerStatus = status;
    },
    setLoading(state, loading) {
      state.loading = loading;
    },
    setAuth(state) {
      state.auth = true;
      localStorage.setItem('auth', true);
    },
    setExistSession(state, isSessionExists) {
      state.isSessionExists = isSessionExists;
    },
    setIsSessionLost(state, isLost) {
      state.isSessionLost = isLost;
    },
    setRestorePasswordButton(state, value) {
      state.showRestorePasswordButton = value;
    },
    setSsoSettings(state, value) {
      state.sso = value;
    }
  },
  actions: {
    async checkSSO({ commit }) {
      try {
        const params = {
          entryPoint: 'ssoParams'
        };
        const { data } = await getController({ params });
        commit('setSsoSettings', data);
      } catch (error) {
        console.error(error);
      }
    },

    async checkAuth() {
      try {
        await getController({
          params: {
            entryPoint: 'check_session_auth'
          }
        });
        return true;
      } catch (error) {
        console.error(error);
        return false;
      }
    },
    async getOfferStatus({ commit }) {
      try {
        const params = {
          entryPoint: 'check_offer_status'
        };
        const { data } = await getController({ params });
        commit('setOfferStatus', data?.offer_status);
        commit(
          'setRestorePasswordButton',
          data?.can_password_change?.show || false
        );
      } catch (error) {
        console.error(error);
      }
    },
    async exitUser({ commit }) {
      try {
        await getController({
          params: {
            module: 'Alerts',
            action: 'get',
            to_pdf: 1
          }
        });

        commit('removeAuth');
        router.push(`/login`);
      } catch (error) {
        return false;
      }
    },
    async authenticate({ commit }, { login, password, ...args }) {
      commit('setLoading', true);
      if (localStorage.getItem('sessionId')) {
        localStorage.removeItem('sessionId');
      }

      try {
        const formData = new FormData();
        const params = {
          module: 'Users',
          action: 'Authenticate',
          user_name: login,
          username_password: password,
          ...args
        };

        for (let key in params) {
          formData.set(key, params[key]);
        }

        const { data } = await postController({
          options: formData
        });

        if (data.status === 'ok') {
          commit('setAuth');
          callNotifications.methods.updateNotifications(true);
        }

        return { status: true, firstLogin: data.first_login };
      } catch (error) {
        if (error.response.data.code === 'SESSION_EXISTS') {
          commit('setExistSession', true);
          return true;
        } else if (error.response.data.code === 'SESSION_LOST') {
          commit('setIsSessionLost', true);
          return true;
        } else if (
          error.response.data.code === 'UNAUTHENTICATED' &&
          error.response.data?.message
        ) {
          errorMsg.methods.showNotification({
            offset: 100,
            showClose: true,
            duration: 25000,
            message: error.response.data.message,
            type: 'error'
          });
        } else {
          console.error(error);
        }
        return false;
      } finally {
        commit('setLoading', false);
      }
    },
    async setNewPassword({ dispatch }, { guid, user_name, new_password }) {
      try {
        const options = new FormData();

        options.append('entryPoint', 'Changenewpassword');
        options.append('guid', guid);
        options.append('user_name', user_name);
        options.append('new_password', new_password);
        options.append('login', 1);

        const { data } = await postController({
          options,
          params: {
            header: {
              'Content-Type': 'application/x-www-form-urlencoded'
            }
          }
        });

        if (data.status === 'ok') {
          errorMsg.methods.showNotification({
            offset: 100,
            showClose: true,
            duration: 25000,
            message: 'Новый пароль успешно установлен',
            type: 'success'
          });
          await dispatch('authenticate', {
            login: user_name,
            password: new_password,
            force: false
          });
          location.reload();
        } else {
          errorMsg.methods.showNotification({
            offset: 100,
            showClose: true,
            duration: 25000,
            message: 'Ошибка при установке нового пароля',
            type: 'error'
          });
        }
      } catch (error) {
        console.error(error);
        return false;
      }
    }
  }
};
